import { useIsFetching, useIsMutating } from "@tanstack/react-query";

export default function LoadingSpinner() {
  const isMutating = useIsMutating();
  const isFetching = useIsFetching({
    predicate: (query) => !query.queryKey.includes("location"),
  });
  if (isMutating || isFetching)
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-PrimaryBlack bg-opacity-30 z-50">
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100/75">
          <img
            src="/GL_Fjäril.png"
            className="w-10 h-10 origin-center animate-bounce"
          />
        </div>
      </div>
    );
}

export function Spinner() {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-PrimaryBlack bg-opacity-30 z-50">
      <div className="absolute inset-0 flex items-center justify-center bg-gray-100/75">
        <img
          src="/GL_Fjäril.png"
          className="w-10 h-10 origin-center animate-bounce"
        />
      </div>
    </div>
  );
}
